import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireGtag } from "/Users/lufei/workspace/GitHub/sy-records/docsify/src/plugins/gtag.js";
var gtagExports = requireGtag();
export { gtagExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(gtagExports);